// extracted by mini-css-extract-plugin
export default {"askQuestionTopText":"Q2-z","yourQuestionLabel":"R2-z","notAuthedMessage":"S2-z","form":"T2-z","textarea":"U2-z","error":"V2-z","disabled":"W2-z","edited":"X2-z","submit":"Y2-z"};